import React from "react";
import { Badge, Tooltip } from "antd";
import { NotificationOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PAGE_RELEASE_NOTES } from "../../pages/Core/routes";

const ReleaseNotesIcon = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const hasUnread = useSelector((state) => state.releaseNotes?.hasUnread);

  const handleClick = () => {
    history.push(PAGE_RELEASE_NOTES);
  };

  return (
    <Tooltip title={t("container.release_notes.title")}>
      <button
        type="button"
        className="link icon-link white release-notes-trigger mr-15"
        onClick={handleClick}
        style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
      >
        <Badge dot={hasUnread} className="release-notes-badge">
          <span className="release-notes-icon-circle">
            <NotificationOutlined />
          </span>
        </Badge>
      </button>
    </Tooltip>
  );
};

export default ReleaseNotesIcon;
